

module.exports = __webpack_require__.stylable.create(
    "SearchSortingBox3532780658",
    {"classes":{"root":"SearchSortingBox3532780658__root","sortBy":"SearchSortingBox3532780658__sortBy","search":"SearchSortingBox3532780658__search","overflowX":"SearchSortingBox3532780658__overflowX"},"vars":{"groupCardBorderColor":"--SearchSortingBox3532780658-groupCardBorderColor","groupCardBorderWidth":"--SearchSortingBox3532780658-groupCardBorderWidth"},"stVars":{},"keyframes":{}},
    "",
    10,
    "SearchSortingBox3532780658",
    null
);
